import { createContext, use } from "react";

import { ISharedDialogStateContextValue } from "./sharedDialogTypes";

export const SharedDialogStateContext = createContext<ISharedDialogStateContextValue | undefined>(undefined);

export const useSharedDialogState = <TState>(): ISharedDialogStateContextValue<TState> => {
  const context = use(SharedDialogStateContext);

  if (!context) {
    throw new Error("useSharedDialogState must be used within SharedDialogProvider.");
  }

  return context as ISharedDialogStateContextValue<TState>;
};
